import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-content',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalContent {
  @Input() content: any;
  @Input() title: any;
  @Input() type: any;
  @Input() action: any;
  @Input() routeTo?: string
  @Input() fnAction?: () => void;

  constructor(public activeModal: NgbActiveModal, public modalService: NgbModal) { }

  closeAllModals() {
    this.modalService.dismissAll(ModalContent);
  }
}

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {
  @Input() title!: string
  @Input() content!: string
  @Input() type?: string
  @Input() action?: string
  @Input() routeTo?: string
  @Input() fnAction?: () => void;

  constructor(private modalService: NgbModal, public activeModal: NgbActiveModal) { }

  ngOnInit(): void { }

  closeAllModals() {
    this.modalService.dismissAll(ModalContent);
  }

  open(title: string, content: string, type: string = this.type ? this.type : 'error', options?: {}, fnAction?: () => void, routeTo?: string) {
    const modalRef = this.modalService.open(ModalContent, options);
    if (fnAction !== undefined) {
      modalRef.componentInstance.fnAction = fnAction;
    }
    modalRef.componentInstance.content = content;
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.type = type;
    modalRef.componentInstance.type = routeTo;
  }
}
